package com.cybersoftsolution.cybersoftsolutionweb.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.api.authenticate
import com.cybersoftsolution.cybersoftsolutionweb.models.AuthResponse
import com.cybersoftsolution.cybersoftsolutionweb.navigation.Screen
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.getUserInfo
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.logout
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.rememberLogin
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import kotlinx.coroutines.delay

@Composable
fun IsAuthenticatedLayout(
    asAdmin : Boolean,
    delay: Long = 1000L,
    content: @Composable () -> Unit
) {
    val context = rememberPageContext()
    val userInfo = getUserInfo()
    val userId = remember {  userInfo.id  }
    val authorizationToken = remember { userInfo.authorizationToken }

//    val userId = remember { localStorage.getItem(USER_ID_KEY) }
//    val authorizationToken = remember { localStorage.getItem(AUTHORIZATION_TOKEN_KEY) }


    var isLoggedIn: Boolean? by remember { mutableStateOf(null) }
    var isAdmin:Boolean by remember { mutableStateOf(false) }
    var authResponse: AuthResponse? by remember { mutableStateOf(null) }



    LaunchedEffect(key1 = Unit) {

        delay(delay)

        if (!userId.isNullOrEmpty() && !authorizationToken.isNullOrEmpty()) {
            authResponse = authenticate(userId, authorizationToken)
            rememberLogin(
                remember = null,
                userId = authResponse?.userInfo?.id,
                authorizationToken = authResponse?.userInfo?.authorizationToken,
                userName = authResponse?.userInfo?.name,
                userEmail = authResponse?.userInfo?.email,
                userEmailVerified = authResponse?.userInfo?.emailVerified,
                userPhone = authResponse?.userInfo?.phone,
                userPicture = authResponse?.userInfo?.picture,
            )

            isLoggedIn = authResponse?.success ?: false
            isAdmin = authResponse?.userInfo?.isAdmin?: false

        } else {
            isLoggedIn = false
            isAdmin = false
        }

    }

    console.info("context.route ------------  " + context.route)
    console.info("context.route.slug ------------  " + context.route.slug)



    when (isLoggedIn) {
        true -> {
            console.log("En {isLoggedIn=True}")
            if (asAdmin) {
                console.log("En {isLoggedIn=True} {asAdmin=True}")
                if (isAdmin) {
                    console.log("En {isLoggedIn=True} {asAdmin=True} {isAdmin=True}")
                    if (context.route.slug.isNotEmpty()) {
                        content()
                    } else {
                        context.router.navigateTo(
                            Screen.AdminHome.route,
                            UpdateHistoryMode.REPLACE,
                            OpenLinkStrategy.IN_PLACE,
                        )
                    }

                } else {
                    console.log("En {isLoggedIn=True} {asAdmin=True} {isAdmin=False}")
                    context.router.navigateTo(
                        Screen.AdminLogin.route,
                        UpdateHistoryMode.REPLACE,
                        OpenLinkStrategy.IN_PLACE,
                    )
                }


            } else {
                console.log("En {isLoggedIn=true} {asAdmin=False}")
                content()
            }

        }
        false -> {


            console.log("En {isLoggedIn=False}")
            if (asAdmin) {
                console.log("En {isLoggedIn=False} {asAdmin=True}")
                context.router.navigateTo(
                    Screen.AdminLogin.route,
                    UpdateHistoryMode.REPLACE,
                    OpenLinkStrategy.IN_PLACE,
                )
            } else {
                console.log("En {isLoggedIn=False} {asAdmin=False}")
//                logout() //Sesion expirada
                content()
            }

        }
        null -> {
                console.log("En {isLoggedIn=Null}")
                content()

        }

    }


}
